import { Breadcrumb } from '@models/breadcrumbs/breadcrumbs.interface';
import { createAction, props } from '@ngrx/store';
import { TitleStrategyData } from '@stores/breadcrumbs/breadcrumbs.reducer';

export const update = createAction('[Breadcrumbs] Update', props<{ breadcrumbs: Breadcrumb[] }>());
export const setTitleStrategyData = createAction(
  '[Breadcrumbs] Set title strategy data',
  props<{ titleStrategyData: TitleStrategyData }>()
);
